import "./App.css";
import { Route, Routes } from "react-router-dom";
import Login from "./features/authentication/components/login/login";
import { AppRoutes } from "./features/authentication/types/app-routes";
import Profile from "./features/profile/components/stock-management/stock-management";
import { useDispatch, useSelector } from "react-redux";
import ProtectedRoute from "./utils/ProtectedRoute";
import { ClipLoader } from "react-spinners";
import SideBar from "./features/common/components/SideBar/SideBar";
import StockManagement from "./features/profile/components/stock-management/stock-management";
import TopBar from "./features/common/components/TopBar/TopBar";
import ConsumptionPerProduct from "./features/profile/components/consumption-per-product/consumption-per-product";
import OtherManagement from "./features/profile/components/other-management/other-management";
import StockView from "./features/profile/components/stock-view/stock-view";
import Settings from "./features/profile/components/settings/settings";
import ShopManagement, { PlanSelectorEnum } from "./features/profile/components/shop-management/shop-management";
import UserManagement from "./features/profile/components/user-management/user-management";
import ConsumptionForecast from "./features/profile/components/consumption-forecast/consumption-forecast";
import Dashboard from "./features/profile/components/dashboard/dashboard";
import MobileNavigation from "./features/common/components/MobileNavigation/MobileNavigation";
import { addLocale } from "primereact/api";
import ActivityLog from "./features/profile/components/activity-log/activity-log";
const fs = require('fs');

const App = () => {
  const isLoaded = useSelector((state: any) => state.auth.isLoaded);

  addLocale('eu', {
    firstDayOfWeek: 1
});
  if (!isLoaded)
    return (
      <div className="app-wrapper">
        <ClipLoader color={"#4F4BFF"} loading={true} size={100} />
      </div>
    );
  else return <App2 />;
};

const App2 = () => {
  const dispatch: Function = useDispatch();
  const user = useSelector((state: any) => state.auth.user);
  const isAuthenticated = useSelector(
    (state: any) => state.auth.isAuthenticated
  );
  const selectedShop = useSelector((state: any) => state.user.selectedShop);
  const isStandardPlan = selectedShop?.plan === PlanSelectorEnum.STANDARD;
  return (
    <div className="app">
        <div className="top-bar-layout">
          {isAuthenticated && <TopBar />}
          {/* <TopBar /> */}
          <div className="side-bar-layout">
            {isAuthenticated && <SideBar />}
            {/* <SideBar /> */}
            <div className="content">
              <Routes>
                <Route path={AppRoutes.LOGIN} element={<Login />} />
                <Route
                  path={`${AppRoutes.DASHBOARD}`}
                  element={
                    <ProtectedRoute
                      fallBack={`${AppRoutes.STOCK_MANAGEMENT}/ice-cream`}
                      condition={isAuthenticated && user.roleLevel >= 2}
                    >
                     <Dashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path={`${AppRoutes.STOCK_MANAGEMENT}/ice-cream`}
                  element={
                    <ProtectedRoute
                      fallBack={AppRoutes.LOGIN}
                      condition={isAuthenticated && user.roleLevel}
                    >
                      <StockManagement />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path={`${AppRoutes.STOCK_MANAGEMENT}/other-products`}
                  element={
                    <ProtectedRoute
                      fallBack={AppRoutes.LOGIN}
                      condition={isAuthenticated && user.roleLevel}
                    >
                      <OtherManagement />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path={`${AppRoutes.STOCK}`}
                  element={
                    <ProtectedRoute
                      fallBack={AppRoutes.LOGIN}
                      condition={isAuthenticated && user.roleLevel}
                    >
                      <StockView/>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path={`${AppRoutes.CONSUMPTION}/product`}
                  element={
                    <ProtectedRoute
                      fallBack={AppRoutes.LOGIN}
                      condition={isAuthenticated && user.roleLevel}
                    >
                      <ConsumptionPerProduct  />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path={`${AppRoutes.CONSUMPTION}/forecast`}
                  element={
                    <ProtectedRoute
                      fallBack={AppRoutes.LOGIN}
                      condition={isAuthenticated && user.roleLevel && !isStandardPlan}
                    >
                      <ConsumptionForecast />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path={`${AppRoutes.SHOP_MANAGEMENT}`}
                  element={
                    <ProtectedRoute
                      fallBack={AppRoutes.LOGIN}
                      condition={isAuthenticated && user.roleLevel}
                    >
                      <ShopManagement />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path={`${AppRoutes.USER_MANAGEMENT}`}
                  element={
                    <ProtectedRoute
                      fallBack={AppRoutes.LOGIN}
                      condition={isAuthenticated && user.roleLevel}
                    >
                      <UserManagement/>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path={`${AppRoutes.SETTINGS}`}
                  element={
                    <ProtectedRoute
                      fallBack={AppRoutes.LOGIN}
                      condition={isAuthenticated && user.roleLevel}
                    >
                      <Settings/>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path={`${AppRoutes.ACTIVITY_LOG}`}
                  element={<ActivityLog />}
                />
              </Routes>
            </div>
            {/* Add mobile navigation */}
            {isAuthenticated && <MobileNavigation />}
          </div>
        </div>
      </div>
  );
};

export default App;
